export class TopicsTreeModel {
  public breadcrumbs: Object[] = [];
  public children: Object[] = [];
}
